import { ChangeDetectionStrategy, Component, OnInit, Signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AnotaLoaderModule, AnotaToastModule } from '@githubanotaai/design-system';
import { LoaderStore, LoaderState } from './store/loader';
import { ToastStore } from './store/toast';
import { GtmResource } from '@infra/gtm';
import { AmplitudeAdapter } from '@infra/trackers/adapters/amplitude.adapter';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AnotaLoaderModule, AnotaToastModule],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  protected loader: Signal<LoaderState>;

  constructor(
    private loaderStore: LoaderStore,
    protected toastStore: ToastStore,
    private amplitudeAdapter: AmplitudeAdapter,
    _gtmResource: GtmResource
  ) {
    this.amplitudeAdapter.init();
    this.loader = this.loaderStore.getState();
  }
}
